module.exports = __webpack_public_path__ + "img/horizontal_4_2_0.3f90ba2f.png";